import { API } from 'src/api';

import { FormField, FormOption } from '../types/form';

export const updateForm = async ({ formId, formData }: { formId: string; formData: any }) => {
  try {
    const response = await API.put(`/forms`, { id: formId, ...formData });
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const getForm = async ({ formId }: { formId: string }) => {
  try {
    const response = await API.get(`/forms?id=${formId}`);
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const getLiveForm = async ({ formId }: { formId: string }) => {
  try {
    const response = await API.get(`/forms/${formId}`);
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const getPublicForm = async ({ formId }: { formId: string }) => {
  try {
    const response = await API.get(`/forms/${formId}`);
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const createFormResponse = async ({
  formId,
  responses,
}: {
  formId: string;
  responses: any[];
}) => {
  try {
    const response = await API.post(`/forms/responses`, { formId, responses });
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const createFormField = async ({
  formId,
  field,
  index,
}: {
  formId: string;
  field: FormField;
  index?: number;
}) => {
  try {
    const response = await API.post(`/forms/fields`, { formId, field, index });
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const updateFormField = async ({
  fieldId,
  formField,
}: {
  fieldId: string;
  formField: FormField;
}) => {
  try {
    const response = await API.put(`/forms/fields`, { id: fieldId, ...formField });
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const deleteFormField = async ({ fieldId }: { fieldId: string }) => {
  try {
    const response = await API.delete(`/forms/fields`, { data: { id: fieldId } });
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
};

export const updateFormProperties = async ({
  id,
  title,
  icon,
  coverImage,
  description,
  showCover,
}: {
  id: string;
  title?: string;
  icon?: any;
  coverImage?: string;
  description?: string;
  showCover?: boolean;
}) => {
  try {
    const response = await API.put(`/forms`, {
      id,
      title,
      icon,
      cover: coverImage,
      description,
      showCover,
    });
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
};

export const addOptionsFormField = async (payload: any) => {
  try {
    const response = await API.post(`/forms/fields/option`, payload);
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const reorderOptionField = async ({ fieldId, value }: { fieldId: string; value: any }) => {
  try {
    const response = await API.put(`/forms/fields/option`, { id: fieldId });
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const deleteOptionsFormField = async (optionId: string) => {
  try {
    const response = await API.delete(`/forms/fields/option?id=${optionId}`);
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
};

export const createFormToTask = async ({
  fileId,
  taskFileTitle,
  workspaceId,
  fieldId,
}: {
  fileId: string;
  taskFileTitle: string;
  workspaceId: string;
  fieldId: string;
}) => {
  try {
    const response = await API.post(`/forms/set-file`, {
      id: fileId,
      title: taskFileTitle,
      workspace: workspaceId,
      field: fieldId,
    });
    if (response.data.success && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

export const updateFormToTask = async ({
  formId,
  fieldId,
}: {
  formId: string;
  fieldId: string;
}) => {
  try {
    const response = await API.put(`/forms/set-file`, {
      form: formId,
      field: fieldId,
    });
    if (response.data.success && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

export const unlinkFormToTask = async (formId: string) => {
  try {
    const response = await API.delete(`/forms/set-file?id=${formId}`);
    if (response.data.success && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

export const deleteFormResponses = async (responses: string[]) => {
  try {
    const response = await API.post(`/forms/responses/delete`, { responses });
    if (response.data.success && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
